import { DatePicker, Form, Input } from 'antd';
import { AmountFields } from '../../../components/AmountFields';
import { EmptyReturnField } from '../../../components/EmptyReturnField';
import type { RateLineProposalView } from '../../../rate-cards.api';

/** What a draft's author may change: price, the empty-return answer, the dates — never the key or the kind. */
export function EditProposalFields({ proposal }: { proposal: RateLineProposalView | null }) {
  return (
    <>
      <AmountFields isCurrencyLocked />
      {proposal?.emptyReturnIncluded != null && <EmptyReturnField />}
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="validFrom" label="Effective from" extra="Must be after today to be approved" rules={[{ required: true, message: 'Choose a date' }]}>
          <DatePicker className="w-full" />
        </Form.Item>
        {proposal?.kind === 'create' && (
          <Form.Item name="validTo" label="Until (optional)">
            <DatePicker className="w-full" />
          </Form.Item>
        )}
      </div>
      <Form.Item name="reason" label="Reason for the change" rules={[{ required: true, whitespace: true, message: 'Say why' }]}>
        <Input.TextArea rows={2} />
      </Form.Item>
    </>
  );
}
